let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j2CZB")).then(() => parcelRequire('gzW4j'));